import { z } from 'zod';
import {
  markerFilterDefaultValue,
  markerFilterSchema
} from 'pages/marking/schemas/shared-filter-form.schema';

export const filterFormSchema = z.intersection(
  z.object({
    groupId: z.string(),
    groupName: z.string()
  }),
  markerFilterSchema
);

export type FilterFormValues = z.infer<typeof filterFormSchema>;

export const groupIdFilterDefaultValue = { groupId: '' };
export const groupNameFilterDefaultValue = { groupName: '' };

export const filterFormDefaultValues: FilterFormValues = {
  ...groupIdFilterDefaultValue,
  ...groupNameFilterDefaultValue,
  ...markerFilterDefaultValue
};
